import type { JSX } from 'react'

import styles from './Notes.module.css'

export function NotesUnreadDivider({ count }: { count: number }): JSX.Element {
  return (
    <li
      data-notes-divider=""
      data-testid="notes-unread-divider"
      className={styles.unreadDivider}
    >
      <hr aria-label={`${count} new ${count === 1 ? 'note' : 'notes'}`} />
      <span>New · {count}</span>
    </li>
  )
}
